import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState, store} from "@/app/store";
import Util from "@/Master/Util";

export interface MainState {
    isDBok: boolean,
}

const initialState: MainState = {
    isDBok: false,
}

export const mainSlice = createSlice({
    name: 'MainState',
    initialState,
    reducers: {
        setMainState: (state, action: PayloadAction<Partial<MainState>>) => {
            if (Util.isLog) {
                console.group('MainState 设置前');
                console.log('MainState 设置前',state,action.payload);
            }

            // 使用 Object.entries 确保我们拿到键值对并做类型检查
            for (const [key, value] of Object.entries(action.payload)) {
                if (key in state) {
                    // 明确指定 key 和 value 的类型
                    state[key as keyof MainState] = value;
                    console.log('MainState payloadKey', key, value);
                }
            }
            // state = {...state, ...action.payload};
            // state.isDBok = action.payload.isDBok;
            if (Util.isLog) {
                console.log('MainState 设置后',state);
                console.groupEnd();
            }
        },
    },
})

export const { setMainState } = mainSlice.actions;

export const mainState = (state: RootState) => state.mainState;

export default mainSlice.reducer;

